const hero = document.querySelector(".jb-hero:not(.jb-hero--no-form)");

if (!hero) return;

/* -------------------------------------------------------------------------- */
/*                               Category Select                              */
/* -------------------------------------------------------------------------- */
const categorySelect = hero.querySelector("#job-category");

if (categorySelect) {
  categorySelect.addEventListener("change", (event) => {
    const selectedCategoryAnchorId = event?.target?.value
      ? String(event.target.value).trim()
      : "";

    if (!selectedCategoryAnchorId) {
      return;
    }

    const headingTarget = document.getElementById(selectedCategoryAnchorId);

    if (!headingTarget) {
      return;
    }

    const groupTarget = headingTarget.closest(".jb-listings__group") || headingTarget;

    const headerOffset = Math.ceil(hero.getBoundingClientRect().height) + 16;
    const targetTop =
      groupTarget.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: "smooth",
    });
  });
}

/* -------------------------------------------------------------------------- */
/*                           Minimization on scroll                           */
/* -------------------------------------------------------------------------- */
const ENTER_MINIMIZED_AT = 28;
const EXIT_MINIMIZED_AT = 0;

let isMinimized = window.scrollY > 30;
let isTicking = false;

const applyState = () => {
  hero.classList.toggle("jb-hero--minimized", isMinimized);
};

const updateFromScroll = () => {
  const scrollTop = window.scrollY || window.pageYOffset || 0;

  if (!isMinimized && scrollTop >= ENTER_MINIMIZED_AT) {
    isMinimized = true;
    applyState();
    return;
  }

  if (isMinimized && scrollTop <= EXIT_MINIMIZED_AT) {
    isMinimized = false;
    applyState();
  }
};

const onScroll = () => {
  if (isTicking) {
    return;
  }

  isTicking = true;
  window.requestAnimationFrame(() => {
    updateFromScroll();
    isTicking = false;
  });
};

applyState();
updateFromScroll();

window.addEventListener("scroll", onScroll, { passive: true });
window.addEventListener("load", updateFromScroll);
